import React from 'react';

export class Flasher extends React.Component {
  render() {
    return (
      this.props.children
    )
  }
}


// WEBPACK FOOTER //
// ./src/visual/component/Flasher.js